import type { NavigationGuardNext } from 'vue-router'

type MiddlewareContext = {
  next: NavigationGuardNext
  [key: string]: unknown
}

type MiddlewareFn = (context: MiddlewareContext) => void

// Caution: every middleware here calls the router's own next() before the one
// after it runs, and the router only honours the first call. So in a chain like
// [auth, internalAdmin] a redirect from the second middleware is ignored and
// the user lands on the page anyway (dev only logs a warning). Do not put a
// middleware that can deny access after one that lets the user through.
const nextFactory = (context: MiddlewareContext, middleware: MiddlewareFn[], index: number): NavigationGuardNext => {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next
  return (...parameters: Parameters<NavigationGuardNext>) => {
    context.next(...parameters as [])
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

export default nextFactory
